import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-oee-states',
  templateUrl: './oee-states.component.html',
  styleUrls: ['./oee-states.component.css']
})
export class OeeStatesComponent implements OnInit {
    public itemsListOeeStates: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadOeeStates() {
        this.itemsListOeeStates = await this.datatask.Post(240);
    }

    private async init() {
        this.loadOeeStates();
    }

    ngOnInit() {
        this.init();
    }
}
